import axios from "axios";

import { I18n } from "react-redux-i18n";
import {
  ORDER_LIST_ATTEMPT,
  ORDER_LIST_SUCCESS,
  ORDER_LIST_FAILED,
  //////////////////////
  ORDER_MORELIST_ATTEMPT,
  ORDER_MORELIST_SUCCESS,
  ORDER_MORELIST_FAILED,
  //////////////////
  ORDER_SET_ITEM
} from "../types/ordersTypes";
import { config } from "../../config";
const url_api = config.api.godiway;

export function loading() {
  return {
    type: ORDER_LIST_ATTEMPT
  };
}

export function success(data) {
  return {
    type: ORDER_LIST_SUCCESS,
    data: data
  };
}

export function failed(error) {
  return {
    type: ORDER_LIST_FAILED,
    error: error
  };
}
////////////////////////////////
export function loadingMore() {
  return {
    type: ORDER_MORELIST_ATTEMPT
  };
}

export function successMore(data) {
  return {
    type: ORDER_MORELIST_SUCCESS,
    data: data
  };
}

export function failedMore(error) {
  return {
    type: ORDER_MORELIST_FAILED,
    error: error
  };
}
///////////////////////////////////////
export function set(item) {
  return {
    type: ORDER_SET_ITEM,
    item: item
  };
}

export const setItem = (data: Object) => async dispatch => {
  dispatch(set(data.item));
}

export const loadList = (data: Object) => async dispatch => {
  dispatch(loading());
  await axios
    .get(url_api + "order", {
      params: {
        id: data.user_id,
        lang: I18n.t("locale")
      },
      headers: { authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(success(response.data.body));
        else dispatch(failed(response.data.body));
      } else {
        dispatch(failed("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failed("try_later"));
      } else {
        dispatch(failed("try_later"));
      }
      return;
    });
};

export const loadListScroll = (data: Object) => async dispatch => {
  dispatch(loadingMore());
  await axios
    .get(url_api + "order", {
      params: {
        id: data.user_id,
        index: data.page_index,
        lang: I18n.t("locale")
      },
      headers: { authorization: `Bearer ${data.token}` },
    })
    .then(function (response) {
      //console.log(response);
      if (response.status < 300) {
        if (response.data.status === "Success")
          dispatch(successMore(response.data.body));
        else dispatch(failedMore(response.data.body));
      } else {
        dispatch(failedMore("try_later"));
      }
    })
    .catch(function (error) {
      console.log(error);
      if (error.Error) {
        dispatch(failedMore("try_later"));
      } else {
        dispatch(failedMore("try_later"));
      }
      return;
    });
};


export const loadItem = (data: Object) => async (dispatch) => {
  try {
    const response = await axios.get(url_api + "order/id", {
      params: data.params,
      headers: { Authorization: `Bearer ${data.token}` },
    });

    if (response.status < 300 && response.data.status === "Success") {
      dispatch(set(response.data.body));
      return response.data.body;
    }

    throw response.data.body || "try_later";
  } catch (error) {
    const message =
      error?.response?.data?.body ||
      (typeof error === "string" ? error : null) ||
      "try_later";
    throw message;
  }
};


